import { buildProps } from '@ll-plus/utils'
import Cascader from './cascader.vue'

import { ExtractPropTypes } from 'vue'

export const cascaderProps = buildProps({
  isGray: {
    type: Boolean,
    default: false,
  },
  // suffixIcon:{
  //   type: String,
  //   default: 'icon-line-arrow-down',
  // },
  // showAllow:{
  //   type: Boolean,
  //   default: true,
  // }
} as const)

// 导出cascaderProps
export type CascaderProps = ExtractPropTypes<typeof cascaderProps>
// 导出cascader实列类型
export type CascaderInstance = InstanceType<typeof Cascader>
